export default __webpack_public_path__ + "static/media/BrainBreak cards77.37b02839.png";